<template>
  <div class="form form-search" id="searchorders">
    <div class="form-group">
      <input type="text" placeholder="Search for Order" class="form-control" v-model="searchTerm" @keyup="showSearchResults" ref="emailInput">
      <input type="submit" value="Search" class="form-search__button" @click="showSearchResults" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchCustomerOrders',
  emits: ['updateOrders'],
  methods: {
    showSearchResults() {
      this.$emit('updateOrders', this.searchTerm);
    }
  },
  data() {
    return {
      searchTerm: this.$route.params.term
    }
  },
  mounted() {
    this.$refs.emailInput.focus();
    var height = document.getElementById("customer-top").offsetHeight + 146
    document.getElementById("searchorders").style.top = `${height}px`;
  }
}
</script>

<style scoped>
  .form-search {
    z-index: 1;
    top: 310px;
    margin: 0;
    position: absolute;
    width: 100%;
  }
  @media screen and (max-width: 992px) {
    .form-search {
     top: 310px;
    }
  }

</style>
